import { render, staticRenderFns } from "./SQuesTwentyFour.vue?vue&type=template&id=54b8f61c&"
import script from "./SQuesTwentyFour.vue?vue&type=script&lang=js&"
export * from "./SQuesTwentyFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports